import { Breadcrumbs, BreadcrumbItem } from './Breadcrumbs';

export * from './Breadcrumbs';

export default { Breadcrumbs, BreadcrumbItem };
